import { SsoProviderType } from "@/orval/gen"

export function getSsoExternalIdClaim(
  providerType?: SsoProviderType
): "oid" | "sid" | undefined {
  switch (providerType) {
    case SsoProviderType.AzureEntraId:
      return "oid"
    case SsoProviderType.AdfsOidc:
      return "sid"
    default:
      return undefined
  }
}
